// import {
//   Avatar,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CardHeader,
//   Chip,
//   CircularProgress,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Grid,
//   List,
//   ListItem,
//   ListItemAvatar,
//   ListItemText,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { useAppSelector } from 'app/hooks';
// import moment from 'moment';
// import React, { useCallback, useEffect, useState } from 'react';
// import { FaCalendarAlt, FaEdit, FaPlus, FaTrash, FaUsers, FaUserShield } from 'react-icons/fa';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   deleteGroup,
//   fetchGroupAvatar,
//   fetchGroups
// } from 'slices/NdisSlices/platformAdmin/PlatformAdminSlice';
// import { RootState } from 'store';
// import { Group } from 'types/ndisSection/platformAdminTypes';
// import { useClientContext } from '../NDIS_section/ProfileMainPage';
// import GroupsAddEditModal from './GroupsAddEditModal';

// const GroupsCard: React.FC = () => {
//   const { selectedClient } = useClientContext();

//   const dispatch = useDispatch();
//   const groups: Group[] = useSelector((state: RootState) => state.platformAdmin?.groups || []);
//   const avatarUrls = useSelector((state: RootState) => state.platformAdmin.avatarUrls);
//   const loading = useSelector((state: RootState) => state.platformAdmin?.loading);
//   const error = useSelector((state: RootState) => state.platformAdmin?.error);

//   const [open, setOpen] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [currentGroup, setCurrentGroup] = useState<Group | null>(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [viewGroup, setViewGroup] = useState<Group | null>(null);
//   const [openViewModal, setOpenViewModal] = useState(false);
//   const [openUsersModal, setOpenUsersModal] = useState(false);
//   const [openAdminsModal, setOpenAdminsModal] = useState(false);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isSmallMobile = useMediaQuery('(max-width:400px)');

//   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
//   const selectedServiceTitle = useAppSelector(
//     (state) => state.serviceSelected.selectedServiceTitle
//   );
//   const componentParentId = location.pathname;

//   // Normalize tags to array
//   const normalizeTags = (tags: string | string[] | undefined): string[] => {
//     if (!tags) return [];
//     if (Array.isArray(tags)) {
//       return tags.filter(Boolean);
//     }
//     return tags.split(',').filter(Boolean);
//   };

//   // Fetch groups only once on mount
//   useEffect(() => {
//     dispatch(fetchGroups() as any);
//   }, [dispatch]);

//   // Fetch avatars for groups that have them and haven't been fetched yet
//   const fetchGroupAvatars = useCallback(() => {
//     groups.forEach((group) => {
//       if (group.avatar && !avatarUrls[group.group_id] && group.avatar.startsWith('data:image/')) {
//         // Store base64 directly in avatarUrls
//         dispatch({
//           type: 'platformAdmin/setAvatarUrl',
//           payload: { id: group.group_id, url: group.avatar }
//         });
//       } else if (group.avatar && !avatarUrls[group.group_id]) {
//         dispatch(fetchGroupAvatar(group));
//       }
//     });
//   }, [groups, avatarUrls, dispatch]);

//   useEffect(() => {
//     fetchGroupAvatars();
//   }, [fetchGroupAvatars]);

//   const handleOpen = (group?: Group) => {
//     setEditMode(!!group);
//     setCurrentGroup(group || null);
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//     setCurrentGroup(null);
//   };

//   const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setSearchTerm(event.target.value);
//   };

//   const filteredGroups = groups.filter((group) =>
//     group.label.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleViewGroup = (group: Group) => {
//     setViewGroup(group);
//     setOpenViewModal(true);
//   };

//   const handleCloseViewModal = () => {
//     setOpenViewModal(false);
//     setViewGroup(null);
//   };

//   const handleOpenUsersModal = () => {
//     setOpenUsersModal(true);
//   };

//   const handleCloseUsersModal = () => {
//     setOpenUsersModal(false);
//   };

//   const handleOpenAdminsModal = () => {
//     setOpenAdminsModal(true);
//   };

//   const handleCloseAdminsModal = () => {
//     setOpenAdminsModal(false);
//   };

//   const handleDeleteGroup = (group: Group) => {
//     dispatch(deleteGroup(group.group_id));
//   };

//   return (
//     <Box sx={{ p: isMobile ? 0.5 : 2 }}>
//       {error && (
//         <Typography
//           color="error"
//           align="center"
//           sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem',pb:1 }}
//         >
//           {error}
//         </Typography>
//       )}
//       {/* Header Section */}
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: isMobile ? 'column' : 'row',
//           justifyContent: 'space-between',
//           alignItems: isMobile ? 'flex-start' : 'center',
//           mb: isMobile ? 1 : 2,
//           gap: isMobile ? 1 : 2
//         }}
//       >
//         <Typography
//           variant={isMobile ? 'h6' : 'h4'}
//           sx={{
//             fontWeight: 600,
//             color: '#333',
//             fontSize: isSmallMobile ? '1rem' : isMobile ? '1rem' : '1.1rem'
//           }}
//         >
//           Manage Groups
//         </Typography>
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: isMobile ? 'column' : 'row',
//             gap: isMobile ? 1 : 2,
//             width: isMobile ? '100%' : 'auto'
//           }}
//         >
//           <TextField
//             label="Search Groups"
//             variant="outlined"
//             size="small"
//             value={searchTerm}
//             onChange={handleSearch}
//             sx={{
//               width: isMobile ? '100%' : 300,
//               fontSize: '0.875rem',
//               '& .MuiInputBase-root': {
//                 height: isMobile ? 36 : 40
//               }
//             }}
//           />
//           <Button
//             variant="contained"
//             color="primary"
//             startIcon={<FaPlus size={isMobile ? 12 : 14} />}
//             onClick={() => handleOpen()}
//             sx={{
//               width: isMobile ? '100%' : 'auto',
//               fontSize: isMobile ? '0.75rem' : '0.875rem',
//               height: isMobile ? 36 : 40
//             }}
//           >
//             New Group
//           </Button>
//         </Box>
//       </Box>
//       {loading ? (
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
//           <CircularProgress size={isMobile ? 24 : 32} />
//         </Box>
//       ) : filteredGroups.length === 0 ? (
//         <Typography
//           align="center"
//           sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem', color: '#666' }}
//         >
//           No groups found
//         </Typography>
//       ) : (
//         <Grid container spacing={isMobile ? 1 : 2}>
//           {filteredGroups.map((group: Group) => (
//             <Grid item xs={12} sm={6} md={4} key={group.group_id}>
//               <Card
//                 sx={{
//                   borderRadius: '8px',
//                   border: '1px solid #ddd',
//                   boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
//                   transition: '0.3s',
//                   '&:hover': { boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)' },
//                   height: '100%',
//                   display: 'flex',
//                   flexDirection: 'column'
//                 }}
//               >
//                 <CardHeader
//                   avatar={
//                     <Avatar
//                       src={
//                         avatarUrls[group.group_id] ||
//                         (group.avatar?.startsWith('data:image/') ? group.avatar : undefined)
//                       }
//                       sx={{
//                         bgcolor: '#1976D2',
//                         color: '#fff',
//                         fontSize: isMobile ? '0.75rem' : '0.875rem',
//                         fontWeight: 'bold',
//                         width: isMobile ? 32 : 40,
//                         height: isMobile ? 32 : 40
//                       }}
//                     >
//                       {group.label.charAt(0).toUpperCase()}
//                     </Avatar>
//                   }
//                   title={
//                     <Typography
//                       variant="subtitle1"
//                       sx={{
//                         fontWeight: 600,
//                         color: '#222',
//                         fontSize: isMobile ? '0.8125rem' : '0.875rem',
//                         lineHeight: 1.2
//                       }}
//                     >
//                       {group.label}
//                     </Typography>
//                   }
//                   sx={{
//                     background: '#F5F5F5',
//                     padding: isMobile ? '8px 8px 8px 4px' : '8px',
//                     '& .MuiCardHeader-content': {
//                       overflow: 'hidden',
//                       textOverflow: 'ellipsis'
//                     }
//                   }}
//                 />
//                 <CardContent
//                   sx={{
//                     p: isMobile ? 1 : 2,
//                     flexGrow: 1,
//                     display: 'flex',
//                     flexDirection: 'column'
//                   }}
//                 >
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: '#555',
//                       mb: 1,
//                       fontSize: isMobile ? '0.6875rem' : '0.75rem',
//                       flexGrow: 1
//                     }}
//                   >
//                     {group.description || 'No description available'}
//                   </Typography>
//                   {group.tags && (
//                     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
//                       {normalizeTags(group.tags).map((tag: string, index: number) => (
//                         <Chip
//                           key={index}
//                           label={`#${tag}`}
//                           size="small"
//                           sx={{
//                             background: '#E3F2FD',
//                             color: '#1976D2',
//                             fontWeight: 500,
//                             fontSize: isMobile ? '0.5625rem' : '0.625rem',
//                             height: isMobile ? 20 : 24
//                           }}
//                         />
//                       ))}
//                     </Box>
//                   )}
//                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 1 }}>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 0.5,
//                         fontSize: isMobile ? '0.6875rem' : '0.75rem'
//                       }}
//                     >
//                       <FaCalendarAlt color="#6c757d" size={isMobile ? 10 : 12} />{' '}
//                       {moment(group.created_at).format('LL')}
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 0.5,
//                         color: '#1976D2',
//                         cursor: 'pointer',
//                         fontSize: isMobile ? '0.6875rem' : '0.75rem'
//                       }}
//                       onClick={() => {
//                         setViewGroup(group);
//                         handleOpenAdminsModal();
//                       }}
//                     >
//                       <FaUserShield size={isMobile ? 10 : 12} /> Admins:{' '}
//                       {group.administrators.length}
//                     </Typography>
//                   </Box>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       mt: 'auto',
//                       gap: isMobile ? 0.5 : 1,
//                       flexDirection: isMobile ? (isSmallMobile ? 'column' : 'row') : 'row'
//                     }}
//                   >
//                     <Button
//                       variant="contained"
//                       startIcon={<FaEdit size={isMobile ? 10 : 12} />}
//                       sx={{
//                         background: '#1976D2',
//                         color: '#fff',
//                         fontWeight: 500,
//                         fontSize: isMobile ? '0.625rem' : '0.75rem',
//                         '&:hover': { background: '#1565C0' },
//                         flex: 1,
//                         minWidth: 0,
//                         px: isMobile ? 0.5 : 1,
//                         py: isMobile ? 0.25 : 0.5
//                       }}
//                       onClick={() => {
//                         handleOpen(group);
//                       }}
//                     >
//                       Edit
//                     </Button>
//                     <Button
//                       variant="contained"
//                       startIcon={<FaUsers size={isMobile ? 10 : 12} />}
//                       sx={{
//                         background: '#388E3C',
//                         color: '#fff',
//                         fontWeight: 500,
//                         fontSize: isMobile ? '0.625rem' : '0.75rem',
//                         '&:hover': { background: '#2E7D32' },
//                         flex: 1,
//                         minWidth: 0,
//                         px: isMobile ? 0.5 : 1,
//                         py: isMobile ? 0.25 : 0.5
//                       }}
//                       onClick={() => handleViewGroup(group)}
//                     >
//                       View
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       startIcon={<FaTrash size={isMobile ? 10 : 12} />}
//                       sx={{
//                         color: '#D32F2F',
//                         borderColor: '#D32F2F',
//                         fontWeight: 500,
//                         fontSize: isMobile ? '0.625rem' : '0.75rem',
//                         '&:hover': { background: '#D32F2F', color: '#fff' },
//                         flex: 1,
//                         minWidth: 0,
//                         px: isMobile ? 0.5 : 1,
//                         py: isMobile ? 0.25 : 0.5
//                       }}
//                       onClick={() => handleDeleteGroup(group)}
//                     >
//                       Delete
//                     </Button>
//                   </Box>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//       )}
//       {open && (
//         <GroupsAddEditModal
//           open={open}
//           handleClose={handleClose}
//           editMode={editMode}
//           currentGroup={
//             currentGroup
//               ? {
//                   ...currentGroup,
//                   services: currentGroup.services.map((service) => service.service_id),
//                   tags: normalizeTags(currentGroup.tags).join(','),
//                   avatar: avatarUrls[currentGroup.group_id] || currentGroup.avatar
//                 }
//               : null
//           }
//         />
//       )}
//       {/* View Group Modal */}
//       <Dialog
//         open={openViewModal}
//         onClose={handleCloseViewModal}
//         maxWidth="sm"
//         fullWidth
//         fullScreen={isMobile}
//       >
//         <DialogTitle
//           sx={{
//             fontWeight: 600,
//             color: '#333',
//             fontSize: isMobile ? '1rem' : '1.25rem',
//             p: isMobile ? 1.5 : 2
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Avatar
//               src={
//                 viewGroup
//                   ? avatarUrls[viewGroup.group_id] ||
//                     (viewGroup.avatar?.startsWith('data:image/') ? viewGroup.avatar : undefined)
//                   : undefined
//               }
//               sx={{
//                 bgcolor: '#1976D2',
//                 color: '#fff',
//                 width: isMobile ? 32 : 40,
//                 height: isMobile ? 32 : 40,
//                 fontSize: isMobile ? '0.75rem' : '0.875rem'
//               }}
//             >
//               {viewGroup?.label.charAt(0).toUpperCase()}
//             </Avatar>
//             {viewGroup?.label}
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ p: isMobile ? 1 : 2 }}>
//           <DialogContentText
//             sx={{
//               mb: isMobile ? 0.5 : 1,
//               fontSize: isMobile ? '0.75rem' : '0.8125rem'
//             }}
//           >
//             {viewGroup?.description || 'No description available'}
//           </DialogContentText>
//           <Box sx={{ mb: isMobile ? 0.5 : 1 }}>
//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#6c757d',
//                 fontSize: isMobile ? '0.75rem' : '0.8125rem',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 0.5
//               }}
//             >
//               <FaCalendarAlt size={isMobile ? 12 : 14} /> Created on:{' '}
//               {moment(viewGroup?.created_at).format('LL')}
//             </Typography>
//           </Box>
//           {viewGroup?.tags && (
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: isMobile ? 0.5 : 1 }}>
//               {normalizeTags(viewGroup.tags).map((tag: string, index: number) => (
//                 <Chip
//                   key={index}
//                   label={`#${tag}`}
//                   size="small"
//                   sx={{
//                     background: '#E3F2FD',
//                     color: '#1976D2',
//                     fontWeight: 500,
//                     fontSize: isMobile ? '0.625rem' : '0.6875rem',
//                     height: isMobile ? 20 : 24
//                   }}
//                 />
//               ))}
//             </Box>
//           )}
//           <Typography
//             variant="subtitle2"
//             sx={{
//               fontWeight: 600,
//               color: '#1976D2',
//               mb: isMobile ? 0.5 : 1,
//               fontSize: isMobile ? '0.8125rem' : '0.875rem'
//             }}
//           >
//             Admins
//           </Typography>
//           <List dense sx={{ py: 0 }}>
//             {viewGroup?.administrators.map((admin: string, index: number) => (
//               <ListItem key={index} sx={{ py: 0, px: 0 }}>
//                 <ListItemAvatar>
//                   <Avatar
//                     sx={{
//                       bgcolor: '#1976D2',
//                       color: '#fff',
//                       width: isMobile ? 28 : 32,
//                       height: isMobile ? 28 : 32,
//                       fontSize: isMobile ? '0.75rem' : '0.8125rem'
//                     }}
//                   >
//                     {admin.charAt(0).toUpperCase()}
//                   </Avatar>
//                 </ListItemAvatar>
//                 <ListItemText
//                   primary={admin}
//                   sx={{
//                     fontSize: isMobile ? '0.75rem' : '0.8125rem',
//                     '& .MuiTypography-root': {
//                       fontSize: 'inherit'
//                     }
//                   }}
//                 />
//               </ListItem>
//             ))}
//           </List>
//           <Typography
//             variant="subtitle2"
//             sx={{
//               fontWeight: 600,
//               color: '#388E3C',
//               mb: isMobile ? 0.5 : 1,
//               fontSize: isMobile ? '0.8125rem' : '0.875rem',
//               mt: isMobile ? 1 : 1.5
//             }}
//           >
//             Services
//           </Typography>
//           <List dense sx={{ py: 0 }}>
//             {viewGroup?.services.map((service, index) => (
//               <ListItem key={index} sx={{ py: 0, px: 0 }}>
//                 <ListItemText
//                   primary={service.label}
//                   sx={{
//                     fontSize: isMobile ? '0.75rem' : '0.8125rem',
//                     '& .MuiTypography-root': {
//                       fontSize: 'inherit'
//                     }
//                   }}
//                 />
//               </ListItem>
//             ))}
//           </List>
//         </DialogContent>
//         <DialogActions sx={{ p: isMobile ? 1 : 2 }}>
//           <Button
//             onClick={handleCloseViewModal}
//             color="primary"
//             sx={{
//               fontSize: isMobile ? '0.75rem' : '0.8125rem',
//               px: isMobile ? 1 : 2,
//               py: isMobile ? 0.5 : 0.75
//             }}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//       {/* Users Modal */}
//       <Dialog
//         open={openUsersModal}
//         onClose={handleCloseUsersModal}
//         maxWidth="sm"
//         fullWidth
//         fullScreen={isMobile}
//       >
//         <DialogTitle
//           sx={{
//             fontWeight: 600,
//             color: '#333',
//             fontSize: isMobile ? '1rem' : '1.25rem',
//             p: isMobile ? 1.5 : 2
//           }}
//         >
//           Users in {viewGroup?.label}
//         </DialogTitle>
//         <DialogContent sx={{ p: isMobile ? 1 : 2 }}>
//           <Typography variant="body2" sx={{ fontSize: isMobile ? '0.75rem' : '0.8125rem' }}>
//             No users available
//           </Typography>
//         </DialogContent>
//         <DialogActions sx={{ p: isMobile ? 1 : 2 }}>
//           <Button
//             onClick={handleCloseUsersModal}
//             color="primary"
//             sx={{
//               fontSize: isMobile ? '0.75rem' : '0.8125rem',
//               px: isMobile ? 1 : 2,
//               py: isMobile ? 0.5 : 0.75
//             }}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//       {/* Admins Modal */}
//       <Dialog
//         open={openAdminsModal}
//         onClose={handleCloseAdminsModal}
//         maxWidth="sm"
//         fullWidth
//         fullScreen={isMobile}
//       >
//         <DialogTitle
//           sx={{
//             fontWeight: 600,
//             color: '#333',
//             fontSize: isMobile ? '1rem' : '1.25rem',
//             p: isMobile ? 1.5 : 2
//           }}
//         >
//           Admins in {viewGroup?.label}
//         </DialogTitle>
//         <DialogContent sx={{ p: isMobile ? 1 : 2 }}>
//           <List dense sx={{ py: 0 }}>
//             {viewGroup?.administrators.map((admin: string, index: number) => (
//               <ListItem key={index} sx={{ py: 0, px: 0 }}>
//                 <ListItemAvatar>
//                   <Avatar
//                     sx={{
//                       bgcolor: '#1976D2',
//                       color: '#fff',
//                       width: isMobile ? 28 : 32,
//                       height: isMobile ? 28 : 32,
//                       fontSize: isMobile ? '0.75rem' : '0.8125rem'
//                     }}
//                   >
//                     {admin.charAt(0).toUpperCase()}
//                   </Avatar>
//                 </ListItemAvatar>
//                 <ListItemText
//                   primary={admin}
//                   sx={{
//                     fontSize: isMobile ? '0.75rem' : '0.8125rem',
//                     '& .MuiTypography-root': {
//                       fontSize: 'inherit'
//                     }
//                   }}
//                 />
//               </ListItem>
//             ))}
//           </List>
//         </DialogContent>
//         <DialogActions sx={{ p: isMobile ? 1 : 2 }}>
//           <Button
//             onClick={handleCloseAdminsModal}
//             color="primary"
//             sx={{
//               fontSize: isMobile ? '0.75rem' : '0.8125rem',
//               px: isMobile ? 1 : 2,
//               py: isMobile ? 0.5 : 0.75
//             }}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default GroupsCard;


import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Snackbar,
  Alert,
  AlertTitle
} from '@mui/material';
import { useAppSelector } from 'app/hooks';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { FaCalendarAlt, FaEdit, FaPlus, FaTrash, FaUsers, FaUserShield } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteGroup,
  fetchGroupAvatar,
  fetchGroups,
  closeSnackbar
} from 'slices/NdisSlices/platformAdmin/PlatformAdminSlice';
import { RootState } from 'store';
import { Group } from 'types/ndisSection/platformAdminTypes';
import { useClientContext } from '../NDIS_section/ProfileMainPage';
import GroupsAddEditModal from './GroupsAddEditModal';

const GroupsCard: React.FC = () => {
  const { selectedClient } = useClientContext();

  const dispatch = useDispatch();
  const groups: Group[] = useSelector((state: RootState) => state.platformAdmin?.groups || []);
  const avatarUrls = useSelector((state: RootState) => state.platformAdmin.avatarUrls);
  const loading = useSelector((state: RootState) => state.platformAdmin?.loading);
  const snackbar = useSelector((state: RootState) => state.platformAdmin.snackbar);

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentGroup, setCurrentGroup] = useState<Group | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [viewGroup, setViewGroup] = useState<Group | null>(null);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [openUsersModal, setOpenUsersModal] = useState(false);
  const [openAdminsModal, setOpenAdminsModal] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmallMobile = useMediaQuery('(max-width:400px)');

  const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
  const selectedServiceTitle = useAppSelector(
    (state) => state.serviceSelected.selectedServiceTitle
  );
  // const componentParentId = location.pathname; caused build issues

  // Normalize tags to array
  const normalizeTags = (tags: string | string[] | undefined): string[] => {
    if (!tags) return [];
    if (Array.isArray(tags)) {
      return tags.filter(Boolean);
    }
    return tags.split(',').filter(Boolean);
  };

  // Fetch groups only once on mount
  useEffect(() => {
    dispatch(fetchGroups() as any);
  }, [dispatch]);

  // Fetch avatars for groups that have them and haven't been fetched yet
  const fetchGroupAvatars = useCallback(() => {
    groups.forEach((group) => {
      if (group.avatar && !avatarUrls[group.group_id] && group.avatar.startsWith('data:image/')) {
        // Store base64 directly in avatarUrls
        dispatch({
          type: 'platformAdmin/setAvatarUrl',
          payload: { id: group.group_id, url: group.avatar }
        });
      } else if (group.avatar && !avatarUrls[group.group_id]) {
        dispatch(fetchGroupAvatar(group));
      }
    });
  }, [groups, avatarUrls, dispatch]);

  useEffect(() => {
    fetchGroupAvatars();
  }, [fetchGroupAvatars]);

  const handleOpen = (group?: Group) => {
    setEditMode(!!group);
    setCurrentGroup(group || null);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentGroup(null);
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const normalizedSearchTerm = searchTerm.toLowerCase();

  const filteredGroups = groups.filter((group) =>
    (group?.label || '').toLowerCase().includes(normalizedSearchTerm)
  );

  const handleViewGroup = (group: Group) => {
    setViewGroup(group);
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setViewGroup(null);
  };

  const handleOpenUsersModal = () => {
    setOpenUsersModal(true);
  };

  const handleCloseUsersModal = () => {
    setOpenUsersModal(false);
  };

  const handleOpenAdminsModal = () => {
    setOpenAdminsModal(true);
  };

  const handleCloseAdminsModal = () => {
    setOpenAdminsModal(false);
  };

  const handleDeleteGroup = (group: Group) => {
    dispatch(deleteGroup(group.group_id));
  };

  const handleSnackbarClose = () => {
    dispatch(closeSnackbar());
  };

  return (
    <Box sx={{ p: isMobile ? 0.5 : 2 }}>
      {/* Header Section */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: isMobile ? 'flex-start' : 'center',
          mb: isMobile ? 1 : 2,
          gap: isMobile ? 1 : 2
        }}
      >
        <Typography
          variant={isMobile ? 'h6' : 'h4'}
          sx={{
            fontWeight: 600,
            color: '#333',
            fontSize: isSmallMobile ? '1rem' : isMobile ? '1rem' : '1.1rem'
          }}
        >
          Manage Groups
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? 1 : 2,
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <TextField
            label="Search Groups"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearch}
            sx={{
              width: isMobile ? '100%' : 300,
              fontSize: '0.875rem',
              '& .MuiInputBase-root': {
                height: isMobile ? 36 : 40
              }
            }}
          />
          <Button
            variant="contained"
            color="primary"
            startIcon={<FaPlus size={isMobile ? 12 : 14} />}
            onClick={() => handleOpen()}
            sx={{
              width: isMobile ? '100%' : 'auto',
              fontSize: isMobile ? '0.75rem' : '0.875rem',
              height: isMobile ? 36 : 40
            }}
          >
            New Group
          </Button>
        </Box>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
          <CircularProgress size={isMobile ? 24 : 32} />
        </Box>
      ) : filteredGroups.length === 0 ? (
        <Typography
          align="center"
          sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem', color: '#666' }}
        >
          No groups found
        </Typography>
      ) : (
        <Grid container spacing={isMobile ? 1 : 2}>
          {filteredGroups.map((group: Group) => (
            <Grid item xs={12} sm={6} md={4} key={group.group_id}>
              <Card
                sx={{
                  borderRadius: '8px',
                  border: '1px solid #ddd',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                  transition: '0.3s',
                  '&:hover': { boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)' },
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <CardHeader
                  avatar={
                    <Avatar
                      src={
                        avatarUrls[group.group_id] ||
                        (group.avatar?.startsWith('data:image/') ? group.avatar : undefined)
                      }
                      sx={{
                        bgcolor: '#1976D2',
                        color: '#fff',
                        fontSize: isMobile ? '0.75rem' : '0.875rem',
                        fontWeight: 'bold',
                        width: isMobile ? 32 : 40,
                        height: isMobile ? 32 : 40
                      }}
                    >
                      {(group.label?.charAt(0) || '?').toUpperCase()}
                    </Avatar>
                  }
                  title={
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 600,
                        color: '#222',
                        fontSize: isMobile ? '0.8125rem' : '0.875rem',
                        lineHeight: 1.2
                      }}
                    >
                      {group.label}
                    </Typography>
                  }
                  sx={{
                    background: '#F5F5F5',
                    padding: isMobile ? '8px 8px 8px 4px' : '8px',
                    '& .MuiCardHeader-content': {
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }
                  }}
                />
                <CardContent
                  sx={{
                    p: isMobile ? 1 : 2,
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#555',
                      mb: 1,
                      fontSize: isMobile ? '0.6875rem' : '0.75rem',
                      flexGrow: 1
                    }}
                  >
                    {group.description || 'No description available'}
                  </Typography>
                  {group.tags && (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
                      {normalizeTags(group.tags).map((tag: string, index: number) => (
                        <Chip
                          key={index}
                          label={`#${tag}`}
                          size="small"
                          sx={{
                            background: '#E3F2FD',
                            color: '#1976D2',
                            fontWeight: 500,
                            fontSize: isMobile ? '0.5625rem' : '0.625rem',
                            height: isMobile ? 20 : 24
                          }}
                        />
                      ))}
                    </Box>
                  )}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 1 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        fontSize: isMobile ? '0.6875rem' : '0.75rem'
                      }}
                    >
                      <FaCalendarAlt color="#6c757d" size={isMobile ? 10 : 12} />{' '}
                      {moment(group.created_at).format('LL')}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        color: '#1976D2',
                        cursor: 'pointer',
                        fontSize: isMobile ? '0.6875rem' : '0.75rem'
                      }}
                      onClick={() => {
                        setViewGroup(group);
                        handleOpenAdminsModal();
                      }}
                    >
                      <FaUserShield size={isMobile ? 10 : 12} /> Admins:{' '}
                      {group.administrators.length}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      mt: 'auto',
                      gap: isMobile ? 0.5 : 1,
                      flexDirection: isMobile ? (isSmallMobile ? 'column' : 'row') : 'row'
                    }}
                  >
                    <Button
                      variant="contained"
                      startIcon={<FaEdit size={isMobile ? 10 : 12} />}
                      sx={{
                        background: '#1976D2',
                        color: '#fff',
                        fontWeight: 500,
                        fontSize: isMobile ? '0.625rem' : '0.75rem',
                        '&:hover': { background: '#1565C0' },
                        flex: 1,
                        minWidth: 0,
                        px: isMobile ? 0.5 : 1,
                        py: isMobile ? 0.25 : 0.5
                      }}
                      onClick={() => {
                        handleOpen(group);
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<FaUsers size={isMobile ? 10 : 12} />}
                      sx={{
                        background: '#388E3C',
                        color: '#fff',
                        fontWeight: 500,
                        fontSize: isMobile ? '0.625rem' : '0.75rem',
                        '&:hover': { background: '#2E7D32' },
                        flex: 1,
                        minWidth: 0,
                        px: isMobile ? 0.5 : 1,
                        py: isMobile ? 0.25 : 0.5
                      }}
                      onClick={() => handleViewGroup(group)}
                    >
                      View
                    </Button>
                    <Button
                      variant="outlined"
                      startIcon={<FaTrash size={isMobile ? 10 : 12} />}
                      sx={{
                        color: '#D32F2F',
                        borderColor: '#D32F2F',
                        fontWeight: 500,
                        fontSize: isMobile ? '0.625rem' : '0.75rem',
                        '&:hover': { background: '#D32F2F', color: '#fff' },
                        flex: 1,
                        minWidth: 0,
                        px: isMobile ? 0.5 : 1,
                        py: isMobile ? 0.25 : 0.5
                      }}
                      onClick={() => handleDeleteGroup(group)}
                    >
                      Delete
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {open && (
        <GroupsAddEditModal
          open={open}
          handleClose={handleClose}
          editMode={editMode}
          currentGroup={
            currentGroup
              ? {
                  ...currentGroup,
                  services: currentGroup.services.map((service) => service.service_id),
                  tags: normalizeTags(currentGroup.tags).join(','),
                  avatar: avatarUrls[currentGroup.group_id] || currentGroup.avatar
                }
              : null
          }
        />
      )}

      {/* View Group Modal */}
      <Dialog
        open={openViewModal}
        onClose={handleCloseViewModal}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            color: '#333',
            fontSize: isMobile ? '1rem' : '1.25rem',
            p: isMobile ? 1.5 : 2
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Avatar
              src={
                viewGroup
                  ? avatarUrls[viewGroup.group_id] ||
                    (viewGroup.avatar?.startsWith('data:image/') ? viewGroup.avatar : undefined)
                  : undefined
              }
              sx={{
                bgcolor: '#1976D2',
                color: '#fff',
                width: isMobile ? 32 : 40,
                height: isMobile ? 32 : 40,
                fontSize: isMobile ? '0.75rem' : '0.875rem'
              }}
            >
              {(viewGroup?.label?.charAt(0) || '?').toUpperCase()}
            </Avatar>
            {viewGroup?.label}
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: isMobile ? 1 : 2 }}>
          <DialogContentText
            sx={{
              mb: isMobile ? 0.5 : 1,
              fontSize: isMobile ? '0.75rem' : '0.8125rem'
            }}
          >
            {viewGroup?.description || 'No description available'}
          </DialogContentText>
          <Box sx={{ mb: isMobile ? 0.5 : 1 }}>
            <Typography
              variant="body2"
              sx={{
                color: '#6c757d',
                fontSize: isMobile ? '0.75rem' : '0.8125rem',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5
              }}
            >
              <FaCalendarAlt size={isMobile ? 12 : 14} /> Created on:{' '}
              {moment(viewGroup?.created_at).format('LL')}
            </Typography>
          </Box>
          {viewGroup?.tags && (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: isMobile ? 0.5 : 1 }}>
              {normalizeTags(viewGroup.tags).map((tag: string, index: number) => (
                <Chip
                  key={index}
                  label={`#${tag}`}
                  size="small"
                  sx={{
                    background: '#E3F2FD',
                    color: '#1976D2',
                    fontWeight: 500,
                    fontSize: isMobile ? '0.625rem' : '0.6875rem',
                    height: isMobile ? 20 : 24
                  }}
                />
              ))}
            </Box>
          )}
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              color: '#1976D2',
              mb: isMobile ? 0.5 : 1,
              fontSize: isMobile ? '0.8125rem' : '0.875rem'
            }}
          >
            Admins
          </Typography>
          <List dense sx={{ py: 0 }}>
            {(viewGroup?.administrators || []).map((admin: string, index: number) => (
              <ListItem key={index} sx={{ py: 0, px: 0 }}>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      bgcolor: '#1976D2',
                      color: '#fff',
                      width: isMobile ? 28 : 32,
                      height: isMobile ? 28 : 32,
                      fontSize: isMobile ? '0.75rem' : '0.8125rem'
                    }}
                  >
                    {(admin?.charAt(0) || '?').toUpperCase()}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={admin}
                  sx={{
                    fontSize: isMobile ? '0.75rem' : '0.8125rem',
                    '& .MuiTypography-root': {
                      fontSize: 'inherit'
                    }
                  }}
                />
              </ListItem>
            ))}
          </List>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 600,
              color: '#388E3C',
              mb: isMobile ? 0.5 : 1,
              fontSize: isMobile ? '0.8125rem' : '0.875rem',
              mt: isMobile ? 1 : 1.5
            }}
          >
            Services
          </Typography>
          <List dense sx={{ py: 0 }}>
            {viewGroup?.services.map((service, index) => (
              <ListItem key={index} sx={{ py: 0, px: 0 }}>
                <ListItemText
                  primary={service.label}
                  sx={{
                    fontSize: isMobile ? '0.75rem' : '0.8125rem',
                    '& .MuiTypography-root': {
                      fontSize: 'inherit'
                    }
                  }}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions sx={{ p: isMobile ? 1 : 2 }}>
          <Button
            onClick={handleCloseViewModal}
            color="primary"
            sx={{
              fontSize: isMobile ? '0.75rem' : '0.8125rem',
              px: isMobile ? 1 : 2,
              py: isMobile ? 0.5 : 0.75
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Users Modal */}
      <Dialog
        open={openUsersModal}
        onClose={handleCloseUsersModal}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            color: '#333',
            fontSize: isMobile ? '1rem' : '1.25rem',
            p: isMobile ? 1.5 : 2
          }}
        >
          Users in {viewGroup?.label}
        </DialogTitle>
        <DialogContent sx={{ p: isMobile ? 1 : 2 }}>
          <Typography variant="body2" sx={{ fontSize: isMobile ? '0.75rem' : '0.8125rem' }}>
            No users available
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: isMobile ? 1 : 2 }}>
          <Button
            onClick={handleCloseUsersModal}
            color="primary"
            sx={{
              fontSize: isMobile ? '0.75rem' : '0.8125rem',
              px: isMobile ? 1 : 2,
              py: isMobile ? 0.5 : 0.75
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Admins Modal */}
      <Dialog
        open={openAdminsModal}
        onClose={handleCloseAdminsModal}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            color: '#333',
            fontSize: isMobile ? '1rem' : '1.25rem',
            p: isMobile ? 1.5 : 2
          }}
        >
          Admins in {viewGroup?.label}
        </DialogTitle>
        <DialogContent sx={{ p: isMobile ? 1 : 2 }}>
          <List dense sx={{ py: 0 }}>
            {(viewGroup?.administrators || []).map((admin: string, index: number) => (
              <ListItem key={index} sx={{ py: 0, px: 0 }}>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      bgcolor: '#1976D2',
                      color: '#fff',
                      width: isMobile ? 28 : 32,
                      height: isMobile ? 28 : 32,
                      fontSize: isMobile ? '0.75rem' : '0.8125rem'
                    }}
                  >
                    {(admin?.charAt(0) || '?').toUpperCase()}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={admin}
                  sx={{
                    fontSize: isMobile ? '0.75rem' : '0.8125rem',
                    '& .MuiTypography-root': {
                      fontSize: 'inherit'
                    }
                  }}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions sx={{ p: isMobile ? 1 : 2 }}>
          <Button
            onClick={handleCloseAdminsModal}
            color="primary"
            sx={{
              fontSize: isMobile ? '0.75rem' : '0.8125rem',
              px: isMobile ? 1 : 2,
              py: isMobile ? 0.5 : 0.75
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for Toasts */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          <AlertTitle>
            {snackbar.severity.charAt(0).toUpperCase() + snackbar.severity.slice(1)}
          </AlertTitle>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default GroupsCard;
